import React, { Fragment, useState } from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import ConfirmationModal from './ConfirmationModal';

const DeleteButton = ({ onDelete, children, isCloseClick, disabled = false }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ConfirmationModal
        isCloseClick={isCloseClick}
        showModal={showModal}
        setShowModal={setShowModal}
        onExec={() => onDelete()}
      >
        {children}
      </ConfirmationModal>
      <Button
        data-test="delete-button"
        className="square-icon-button"
        style={{ marginLeft: 8, border: '1px solid transparent', backgroundColor: 'transparent' }}
        onClick={(e) => {
          if (isCloseClick) {
            e.stopPropagation();
          }
          // для гашения фокуса после нажатия
          e.target.blur();
          setShowModal(!showModal);
        }}
        disabled={disabled}
      >
        <DeleteOutlined />
      </Button>
    </>
  );
};

export default DeleteButton;
